import { Injectable } from '@angular/core';

import { SportsProductUtils } from '@frontend/sports/host-app/sports-product/feature/utils';
import { ReplaySubject, combineLatest, map } from 'rxjs';

import { AccaBoostTokenProviderService } from '../../../../lib/acca-boost-base/acca-boost-token-provider.service';
import { CrmOfferLoaderService } from '../../../../lib/crm-offer-data/crm-offer-loader.service';
import { IRewardTokenData } from '../../../../lib/tokens-base/token-base.models';
import { IRewardToken } from '../reward-tokens.model';
import { RewardTokensFactory } from './reward-tokens.factory';

@Injectable({ providedIn: 'root' })
export class RewardTokensDataService {
    private readonly tokens$$ = new ReplaySubject<IRewardToken[]>(1);
    readonly tokens$ = this.tokens$$.asObservable();

    constructor(
        private crmOfferLoaderService: CrmOfferLoaderService,
        private rewardTokensFactory: RewardTokensFactory,
        private accaBoostTokenProvider: AccaBoostTokenProviderService,
        private productUtils: SportsProductUtils,
    ) {}

    init(): void {
        const crmTokens$ = this.crmOfferLoaderService.tokens$.pipe(map(this.mapCrmTokens));
        const accaBoostTokens$ = this.accaBoostTokenProvider.tokens$;
        combineLatest([crmTokens$, accaBoostTokens$])
            .pipe(
                this.productUtils.filterSportsEmitLast(),
                map(([crmTokens, accaBoostTokens]) => {
                    return [...crmTokens, ...accaBoostTokens];
                }),
            )
            .subscribe((tokens) => this.tokens$$.next(tokens));
    }

    refreshCrmOffer(): void {
        this.crmOfferLoaderService.refresh();
    }

    refreshAccaOffer(): void {
        this.accaBoostTokenProvider.refresh();
    }

    private mapCrmTokens = (crmTokensData: IRewardTokenData[]): IRewardToken[] => {
        return this.rewardTokensFactory.toModelList(crmTokensData);
    };
}
